export default "__VITE_ASSET__DS5U6JU0__"